// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./crowdfunding-bg.jpg");
var dir = previousRequest.replace("crowdfunding-bg.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "crowdfunding-bg.jpg",
	name: "crowdfunding-bg",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/crowdfunding-bg.jpg
// module id = 28
// module chunks = 4